module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Also by Michael Foley")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Britain’s Railway Disasters: Fatal Accidents from the 1830s to the Present Day")]), _vm._v(" (Pen and Sword, 2019 & 2013)")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Essex: Ready for Anything")]), _vm._v(" (Sutton Publishing, 2006)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fac3696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Also.vue
// module id = 60
// module chunks = 0